import {barnManagerModule} from '../../index.module';

barnManagerModule
  .constant('MessageFrames', {
    DEFAULT: 'default',
    TOP: 'top',
    RIGHT: 'right'
  });

